import { FC } from 'react'

import { ButtonSize } from '@tribeplatform/react-ui-kit/Button'
import { Divider } from '@tribeplatform/react-ui-kit/Divider'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useStaticIntl } from '../../i18n/hooks/useStaticIntl.js'
import { useI18n } from '../../i18n/index.js'
import { useComposerConfig } from '../ComposerConfigContext.js'
import {
  slashMenuItemsFactory,
  MenuItem,
} from '../extensions/slash-menu/items.js'
import { useComposer } from '../hooks/index.js'

import { ComposerIconButton } from './ComposerIconButton.js'

interface Props {
  onItemClick: (props: MenuItem) => void
  size?: ButtonSize
}

export const SlashMenuButton: FC<Props> = ({ onItemClick, size }) => {
  const { $t } = useI18n()
  const { extensions } = useComposerConfig()
  const { poll } = useComposer()
  const getItems = useStaticIntl(slashMenuItemsFactory)
  const items = getItems(extensions, {
    canCreatePoll: !!poll,
  })

  return (
    <Dropdown>
      <Dropdown.ButtonMinimal
        aria-label={$t({
          id: 'Generics.SlashMenu',
          defaultMessage: 'Slash menu',
        })}
      >
        <ComposerIconButton
          as="span"
          size={size}
          icon={<SvgIcon name="zap" />}
        />
      </Dropdown.ButtonMinimal>
      <Dropdown.Items maxHeight="sm">
        {items.map((item, index) => {
          if (item.type === 'divider') {
            // eslint-disable-next-line react/no-array-index-key
            return <Divider key={`divider-${index}`} padding="sm" />
          }
          return (
            <Dropdown.Item
              onClick={() => onItemClick(item)}
              key={item.label}
              leadingIcon={item.icon}
            >
              {item.label}
            </Dropdown.Item>
          )
        })}
      </Dropdown.Items>
    </Dropdown>
  )
}
